import {
  BridgeIcon,
  Building02Icon,
  CircleIcon,
  EnergyIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import {
  BridgeIcon as BridgeDuotoneIcon,
  Building02Icon as Building02DuotoneIcon,
  CircleIcon as CircleDuotoneIcon,
  EnergyIcon as EnergyDuotoneIcon,
} from '@hugeicons-pro/core-duotone-rounded';
import { Icon } from '@/ui/components/icon';
import type { ProjectType } from '@/features/projects/constants';

const ICONS = {
  BUILDING: Building02Icon,
  INFRASTRUCTURE: BridgeIcon,
  ENERGY: EnergyIcon,
} satisfies Record<ProjectType, unknown>;

const DUOTONE_ICONS = {
  BUILDING: Building02DuotoneIcon,
  INFRASTRUCTURE: BridgeDuotoneIcon,
  ENERGY: EnergyDuotoneIcon,
} satisfies Record<ProjectType, unknown>;

export function ProjectTypeIcon({
  type,
  variant,
  className,
}: {
  type: ProjectType | null | undefined;
  variant?: 'duotone';
  className?: string;
}) {
  const icons = variant === 'duotone' ? DUOTONE_ICONS : ICONS;
  const fallback = variant === 'duotone' ? CircleDuotoneIcon : CircleIcon;
  return <Icon width={16} height={16} icon={type ? icons[type] : fallback} className={className} />;
}
